interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  color?: string
  message?: string
}

export default function LoadingSpinner({ 
  size = 'md', 
  color = 'yellow-500', 
  message = '読み込み中...' 
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-12 w-12', 
    lg: 'h-16 w-16'
  }

  return (
    <div className="flex flex-col items-center justify-center space-y-4">
      <div className={`animate-spin rounded-full border-b-2 border-${color} ${sizeClasses[size]}`}></div>
      {message && (
        <p className="text-gray-600 text-sm">{message}</p>
      )}
    </div>
  )
}